import DnDTable from './DnDTable';

export default DnDTable;
